import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ user, allowedRoles, children }) {
  // 1. Jika user belum login, lempar ke halaman Login
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // 2. Jika roles didefinisikan, cek apakah role user ada di dalam daftar yang diizinkan
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Jika role tidak cocok (misal: siswa mencoba masuk halaman admin)
    // Kita kembalikan ke Dashboard (/) tanpa memberi tahu url itu ada
    return <Navigate to="/" replace />;
  }

  // 3. Jika aman, tampilkan halaman yang dituju
  return children;
}
